import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { IUpdateUserConsentsPayload, IUpdateUserConsentsResult } from "./types";

export async function updateUserConsents(
  data: IUpdateUserConsentsPayload
): Promise<IUpdateUserConsentsResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/consents/bulk`,
    {
      method: "post",
      json: data,
    }
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    throw new Error("Error while updating consents");
  }

  return result;
}
